import { Tooltip } from "@mui/material";
import * as React from "react";

interface ExcerptLinkProps {
  text: string;
  url?: string;
  index: number;
  author?: string;
  title?: string;
}

const ExcerptLink: React.FC<ExcerptLinkProps> = ({
  text,
  url,
  index,
  author,
  title,
}) => {
  return (
    <>
      {index !== 1 && (
        <>
          <br />
          <br />
        </>
      )}

      {"["}
      <Tooltip title={`${title} published by ${author}`}>
        <a href={url} target="_blank" rel="noreferrer">
          {text}
        </a>
      </Tooltip>
      {"]"}
    </>
  );
};

export default ExcerptLink;
